(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dl-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.dl-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answerId = btn.getAttribute('aria-controls');
      var answer   = document.getElementById(answerId);
      if (!answer) return;

      if (expanded) {
        btn.setAttribute('aria-expanded', 'false');
        answer.classList.remove('is-open');
      } else {
        btn.setAttribute('aria-expanded', 'true');
        answer.classList.add('is-open');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
